export default __webpack_public_path__ + "static/BG4-fdc792dfcd2b5ad866cfd6eab13617db.png";